"use strict";

var _objectWithoutProperties = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
var _excluded = ["vertex"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convInputs;
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var makeEdgeId = function makeEdgeId(edge) {
  return "".concat(edge.from, "\x0B").concat(edge.to);
};
function unmapVertices(idToVertex, output) {
  return output.map(function (lv) {
    var sv = idToVertex.get(lv.vertex.key);
    if (!sv) {
      throw new Error("Unable to find Vertex for ".concat(lv.vertex.key));
    }
    return _objectSpread(_objectSpread({}, lv), {}, {
      vertex: sv.vertex
    });
  });
}
function unmapEdges(idsToEdge, output) {
  return output.map(function (le) {
    var id = makeEdgeId(le.edge);
    var edge = idsToEdge.get(id);
    if (!edge) {
      throw new Error("Unable to find edge for ".concat(id));
    }
    return _objectSpread(_objectSpread({}, le), {}, {
      edge: edge
    });
  });
}
function convInputs(srcEdges, inVertices) {
  var keyToId = new Map();
  var idToVertex = new Map();
  var idsToEdge = new Map();
  var vertices = inVertices.map(function (v) {
    var key = v.vertex.key,
      rest = _objectWithoutProperties(v, _excluded);
    if (keyToId.has(key)) {
      throw new Error("Non-unique vertex key: ".concat(key));
    }
    var id = String(keyToId.size);
    keyToId.set(key, id);
    idToVertex.set(id, v);
    return _objectSpread({
      vertex: {
        key: id
      }
    }, rest);
  });
  var edges = srcEdges.map(function (e) {
    var from = e.from,
      to = e.to,
      isBidirectional = e.isBidirectional;
    var fromId = keyToId.get(from);
    var toId = keyToId.get(to);
    if (fromId == null) {
      throw new Error("Unrecognized key on edge, from: ".concat(from));
    }
    if (toId == null) {
      throw new Error("Unrecognized key on edge, to: ".concat(to));
    }
    var edge = {
      isBidirectional: isBidirectional,
      from: fromId,
      to: toId
    };
    idsToEdge.set(makeEdgeId(edge), e);
    return edge;
  });
  return {
    edges: edges,
    vertices: vertices,
    unmapEdges: unmapEdges.bind(null, idsToEdge),
    unmapVertices: unmapVertices.bind(null, idToVertex)
  };
}